import { render, staticRenderFns } from "./FoodOrigin.vue?vue&type=template&id=591fffd4&"
import script from "./FoodOrigin.vue?vue&type=script&lang=js&"
export * from "./FoodOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports